import TranslationService from './TranslationService';

export default function translateDOM(root) {
  const ts = TranslationService.getInstance();
  const ctx = root || document;

  ctx.querySelectorAll('[data-lang]').forEach(el => {
    const key = el.getAttribute('data-lang');
    if (!key) return;
    const text = ts.t(key);
    if (text && text !== key) {
      applyTranslation(el, text);
    }
  });

  ctx.querySelectorAll('[data-lang-attr]').forEach(el => {
    const attr = el.getAttribute('data-lang-attr');
    const key = el.getAttribute(`data-lang-${attr}`);
    if (!attr || !key) return;
    const text = ts.t(key);
    if (text && text !== key && el.getAttribute(attr) !== text) {
      el.setAttribute(attr, text);
    }
  });

  ctx.querySelectorAll('[data-lang-html]').forEach(el => {
    const key = el.getAttribute('data-lang-html');
    if (!key) return;
    const varsAttr = el.getAttribute('data-lang-vars');
    let text;
    if (varsAttr) {
      try {
        const vars = JSON.parse(varsAttr);
        text = ts.tWithVars(key, vars);
      } catch (e) {
        text = ts.t(key);
      }
    } else {
      text = ts.t(key);
    }
    if (text && text !== key && el.innerHTML !== text) {
      el.innerHTML = text;
    }
  });

  const currentLang = ts.getLang();
  if (document.documentElement.lang !== currentLang) {
    document.documentElement.lang = currentLang;
  }
}

function applyTranslation(el, text) {
  const tag = el.tagName;
  const type = (el.getAttribute('type') || '').toLowerCase();

  if (tag === 'INPUT' || tag === 'TEXTAREA') {
    if (type === 'submit' || type === 'button' || type === 'reset') {
      if (el.value !== text) {
        el.value = text;
      }
    } else if (type === 'hidden') {
      return;
    } else {
      if (el.placeholder !== text) {
        el.placeholder = text;
      }
    }
  } else if (tag === 'IMG') {
    if (el.alt !== text) {
      el.alt = text;
    }
  } else if (tag === 'META') {
    if (el.content !== text) {
      el.content = text;
    }
  } else if (tag === 'LABEL') {
    if (el.textContent !== text) {
      el.textContent = text;
    }
  } else if (tag === 'OPTION') {
    if (el.textContent !== text) {
      el.textContent = text;
    }
  } else if (el.getAttribute('role') === 'tooltip' || el.classList.contains('MuiTooltip-tooltip')) {
    if (el.textContent !== text) {
      el.textContent = text;
    }
  } else {
    if (el.textContent !== text) {
      el.textContent = text;
    }
  }
}

if (typeof window !== 'undefined') {
  window.translateDOM = translateDOM;
}
